import { Product, SavedProduct } from '@/types';
import { getAllProductsFromCart, getUniqueKey } from '../TopLevel';

export const addToCart = async (products: Product[], cart: SavedProduct[], setCart: React.Dispatch<React.SetStateAction<SavedProduct[]>>, signedIn: boolean, showSnackbar: (time: number, status: number, message: string) => void, is1kg: boolean, desc: string = ""
) => {
    const item = cart.find((item) => (item.id == getUniqueKey(products.map((item) => item.id as number)) && item.is1kg == is1kg));

    if (item) {
        await increaseQuantity(products[0].uniqueid, item.packids, cart, setCart, signedIn, showSnackbar, is1kg);
    }
    else {
        const newCart = [...cart, {
            id: getUniqueKey(products.map((item) => item.id as number)),
            quantity: 1,
            uniqueid: products[0].uniqueid,
            price: products.reduce((acc, curr) => {
                if (!is1kg) {
                    if (typeof curr.price == "string")
                        return acc as number + parseFloat(curr.price);
                    else
                        return acc as number + curr.price as number;
                } else {
                    if (typeof curr.price1kg == "string")
                        return acc as number + parseFloat(curr.price1kg);
                    else
                        return acc as number + curr.price1kg as number;
                }
            }, 0),
            products: products.map((item, i) => {
                return {
                    ...item,
                    id: `${item.id}-${i}`
                }
            }),
            category: products[0].category,
            packids: products.map((item) => item.id as number),
            description: desc,
            is1kg: is1kg
        }];
        if (signedIn) {
            showSnackbar(3000, 0, "Added to cart");
            await incServerQuantity(products[0].uniqueid, products.map((item) => item.id as number), newCart, cart, setCart, showSnackbar, is1kg)
        }
        else {
            setCart(newCart);
            localStorage.setItem("cart", JSON.stringify(
                removeCartProps(newCart)
            ));
            showSnackbar(3000, 0, "Added to cart");
        }
    }
};

export const getCart = async (signedIn: boolean, cartState: SavedProduct[], setCart: React.Dispatch<React.SetStateAction<SavedProduct[]>>) => {
    if (signedIn) {
        localStorage.removeItem("cart");
        await getCartFromServer(setCart);
    }
    else {
        const cart = JSON.parse(localStorage.getItem("cart") || "[]")
        const products = await getAllProductsFromCart(cart)
        const newCart = addCartProps(cart, products)
        setCart(newCart);
    }
};


export const increaseQuantity = async (uid: string, ids: number[], cart: SavedProduct[], setCart: React.Dispatch<React.SetStateAction<SavedProduct[]>>, signedIn: boolean, showSnackbar: (time: number, status: number, message: string) => void, is1kg: boolean) => {
    const newCart = cart.map((item) => {
        if (item.id === getUniqueKey(ids) && item.is1kg === is1kg) {
            item.quantity++;
        }
        return item;
    });
    if (signedIn) {
        showSnackbar(3000, 0, "Increased Quantity");
        await incServerQuantity(uid, ids, newCart, cart, setCart, showSnackbar, is1kg);
    }
    else {
        setCart(newCart);
        localStorage.setItem("cart", JSON.stringify(
            removeCartProps(newCart)
        ));
        showSnackbar(3000, 0, "Increased Quantity");
    }
}

export const decreaseQuantity = async (uid: string, ids: number[], cart: SavedProduct[], setCart: React.Dispatch<React.SetStateAction<SavedProduct[]>>, signedIn: boolean, showSnackbar: (time: number, status: number, message: string) => void, is1kg: boolean) => {
    const newCart = cart.map((item) => {
        if (item.id === getUniqueKey(ids) && item.is1kg === is1kg) {
            item.quantity > 1 ? item.quantity-- : item.quantity = 1;
        }
        return item;
    });
    if (signedIn) {
        showSnackbar(3000, 0, "Decreased Quantity");
        await decServerQuantity(uid, ids, newCart, cart, setCart, showSnackbar, is1kg);
    }
    else {
        setCart(newCart);
        localStorage.setItem("cart", JSON.stringify(
            removeCartProps(newCart)
        ));
        showSnackbar(3000, 0, "Decreased Quantity");
    }
}

export const removeFromCart = async (uid: string, ids: number[], cart: SavedProduct[], setCart: React.Dispatch<React.SetStateAction<SavedProduct[]>>, signedIn: boolean, showSnackbar: (time: number, status: number, message: string) => void, is1kg: boolean) => {
    if ((cart.find((item) => item.id === getUniqueKey(ids) && item.is1kg === is1kg)?.quantity ?? 0) > 1) {
        await decreaseQuantity(uid, ids, cart, setCart, signedIn, showSnackbar, is1kg);
        return;
    }
    const newCart = cart.filter((item) => item.id !== getUniqueKey(ids) || item.is1kg !== is1kg);
    if (signedIn) {
        showSnackbar(3000, 0, "Removed from cart");
        await decServerQuantity(uid, ids, newCart, cart, setCart, showSnackbar, is1kg);
    }
    else {
        setCart(newCart);
        localStorage.setItem("cart", JSON.stringify(
            removeCartProps(newCart)
        ));
        showSnackbar(3000, 0, "Removed from cart");
    }
}

export const getTotal = (cart: SavedProduct[], flatShipping: number): number => {
    const sub = getCartSubTotal(cart);
    return (sub + flatShipping);
};

export const getCartSubTotal = (cart: SavedProduct[]): number => {
    if (cart.length > 0) {
        let total = 0;
        cart.forEach((item) => {
            const productTotal = item.products.reduce((acc, curr) => {
                if (item.is1kg) {
                    if (typeof curr.price1kg == "string")
                        return acc as number + parseFloat(curr.price1kg);
                    else
                        return acc as number + curr.price1kg as number;
                } else {
                    if (typeof curr.price == "string")
                        return acc as number + parseFloat(curr.price);
                    else
                        return acc as number + curr.price as number;
                }
            }, 0)
            total += productTotal * item.quantity
        })
        return total;
    } else {
        return 0;
    }
};




const getCartFromServer = async (setCart: React.Dispatch<React.SetStateAction<SavedProduct[]>>) => {
    const response = await fetch("/api/user/cart", {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const data = await response.json();
    if (data.message == "success") {
        setCart(data.cart);
        localStorage.setItem("cart", JSON.stringify(
            removeCartProps(data.cart)
        ));
    }
    else {
        console.log(data.message);
    }
}

export const decServerQuantity = async (uid: string, ids: number[], cart: SavedProduct[], oldCart: SavedProduct[], setCart: React.Dispatch<React.SetStateAction<SavedProduct[]>>, showSnackbar: (time: number, status: number, message: string) => void, is1kg: boolean) => {
    setCart(cart);
    const response = await fetch("/api/user/cart", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "id": ids,
            "action": "remove",
            "uid": uid,
            "is1kg": is1kg
        })
    });
    const data = await response.json();
    if (data.message == "success") {
        localStorage.setItem("cart", JSON.stringify(
            removeCartProps(cart)
        ));
    }
    else {
        setCart(oldCart);
        console.log(data.error);
        showSnackbar(3000, 1, "Something went wrong");
    }
}

async function incServerQuantity(uid: string, ids: number[], cart: SavedProduct[], oldCart: SavedProduct[], setCart: React.Dispatch<React.SetStateAction<SavedProduct[]>>, showSnackbar: (time: number, status: number, message: string) => void, is1kg: boolean) {
    setCart(cart);
    const response = await fetch("/api/user/cart", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "id": ids,
            "action": "add",
            "uid": uid,
            "is1kg": is1kg
        })
    });
    const data = await response.json();
    if (data.message == "success") {
        localStorage.setItem("cart", JSON.stringify(
            removeCartProps(cart)
        ));
    }
    else {
        setCart(oldCart);
        showSnackbar(3000, 1, "Something went wrong");
        console.log(data.error);
    }
}


export const removeCartProps = (cart: SavedProduct[]) => {
    return cart.map(
        (item: SavedProduct) => {
            return {
                id: item.id,
                quantity: item.quantity,
                uniqueid: item.uniqueid,
                packids: item.packids,
                description: item.description || "",
                is1kg: item.is1kg
            }
        }
    )
}

export const addCartProps = (cart: SavedProduct[], products: Product[]) => {
    return cart.map(
        (item: SavedProduct) => {
            const reqProducts = item.packids.map(
                (id: number) => products.find((product: Product) => product.id == id)
            ) as Product[];
            return {
                id: item.id,
                quantity: item.quantity,
                uniqueid: item.uniqueid,
                price: !item.is1kg ? reqProducts.reduce((acc, curr) => {
                    if (typeof curr.price == "string")
                        return acc as number + parseFloat(curr.price);
                    else
                        return acc as number + curr.price as number;
                }, 0) : reqProducts.reduce((acc, curr) => {
                    if (typeof curr.price1kg == "string")
                        return acc as number + parseFloat(curr.price1kg);
                    else
                        return acc as number + curr.price1kg as number;
                }, 0),
                category: reqProducts.find((product: Product) => product.uniqueid == item.uniqueid)?.category as string,
                products: item.packids.map(
                    (id: number, i) => {
                        const product = reqProducts.find((product: Product) => product.id == id) as Product;
                        return {
                            ...product,
                            id: `${product.id}-${i}`
                        }
                    }
                ) as Product[],
                packids: item.packids,
                description: item.description || "",
                is1kg: item.is1kg
            }
        }
    )
}